import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      color: palette.text.primary,
      display: 'flex',
      gap: '10px',
      padding: '2px',
      cursor: 'pointer',
      userSelect: 'none',
      backgroundColor: palette.background.underBox,
      borderRadius: '10px'
    },
    mobile: {
      paddingRight: '10px'
    },
    pseudo: {
      fontSize: '18px',
      fontWeight: 700,
      cursor: 'pointer',
      marginTop: '2px'
    },
    pseudoMobile: {
      fontSize: '19px',
      fontWeight: 700,
      cursor: 'pointer',
      marginTop: '2px'
    },
    role: {
      fontSize: '15px',
      fontWeight: 300,
      cursor: 'pointer',
      margin: 0
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
